import React, {useEffect, useState} from "react";
import {AdministrativeRolesFormEdit} from "../../components/administrative-roles/AdministrativeRolesFormEdit";
import {useSearchParams} from "react-router-dom";
import {useGetAdministrativeRoleQuery} from "../../store/backend-api/backend.api";

export function EditAdministrativeRolesForm() {
    const [searchParams] = useSearchParams()
    const id = Number(searchParams.get("id"))
    const {data, isSuccess} = useGetAdministrativeRoleQuery(id)
    const [key, setKey] = useState(0)

    useEffect(() => {
        setKey((prevState) => prevState + 1)
    }, [data])

    return (<div key={key}>
        {isSuccess && <AdministrativeRolesFormEdit data={data}/>}
    </div>)
}